import { BOM } from "./definedMethod";

export default {
  GetCompanyTemplate: BOM.baseUrl("getCompanyTemplate"),
};


